import moment from 'moment';

import { Http } from '../../../support';

const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
const to = moment().format('YYYY-MM-DD');

export const initialState = {
  busy: false,
  data: [],
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
    from,
    to,
    tipo: ['autofacturacion'],
  },
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    state.modulo.autofacturacion.archivos = {
      ...state.modulo.autofacturacion.archivos,
      ...data,
    };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.modulo.autofacturacion.archivos.data = {
      ...state.modulo.autofacturacion.archivos.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.modulo.autofacturacion.archivos = {
      ...state.modulo.autofacturacion.archivos,
      result: undefined,
      error: undefined,
      busy: true,
      pagination: {
        ...state.modulo.autofacturacion.archivos.pagination,
        ...params,
      },
    };
  });

  try {
    const { pagination } = store.state.modulo.autofacturacion.archivos;

    const body = {
      ...pagination,
      ...params,
    };

    const response = await Http.get(`/api/excel-files`, { params: body });

    store.setState((state) => {
      state.modulo.autofacturacion.archivos = {
        ...state.modulo.autofacturacion.archivos,
        busy: false,
        data: response.data,
        pagination: {
          ...state.modulo.autofacturacion.archivos.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.autofacturacion.archivos.busy = false;
      state.modulo.autofacturacion.archivos.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.autofacturacion.archivos = {
      ...initialState,
    };
  });
};

const AutofacturacionListStore = {
  state: () => initialState,
  actions: {
    change,
    setSelectedRows,
    paginate,
    reset,
  },
};

export default AutofacturacionListStore;
